import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "form_checkbox_filled",
  "use": "form_checkbox_filled-usage",
  "viewBox": "0 0 40 40",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" viewBox=\"0 0 40 40\" id=\"form_checkbox_filled\">\n  <path d=\"M20,0A20,20,0,1,0,40,20,20,20,0,0,0,20,0ZM30.25,13.89,16.75,27.4a.8.8,0,0,1-1.13,0L9.75,21.53A.89.89,0,0,1,11,20.27l5.18,5.18L29,12.63a.89.89,0,0,1,1.26,1.26Z\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol